var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWrappedClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 589",
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#030303",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1212 9.70696C9.73065 10.0975 9.73065 10.7306 10.1212 11.1212L14.9998 15.9998L9.70696 21.2927C9.31643 21.6833 9.31643 22.3164 9.70696 22.707C10.0975 23.0975 10.7306 23.0975 11.1212 22.707L16.4141 17.4141L21.4349 22.4349C21.8254 22.8254 22.4586 22.8254 22.8491 22.4349C23.2396 22.0444 23.2396 21.4112 22.8491 21.0207L17.8283 15.9998L22.4349 11.3932C22.8254 11.0027 22.8254 10.3696 22.4349 9.97903C22.0444 9.58851 21.4112 9.58851 21.0207 9.97903L16.4141 14.5856L11.5354 9.70696C11.1449 9.31643 10.5117 9.31643 10.1212 9.70696Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrappedClose);
export default __webpack_public_path__ + "static/media/wrapped-close.ed56ada7528a6ad8032f2514df03524c.svg";
export { ForwardRef as ReactComponent };